var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A8ADB7;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#D12E26;}\n\t.st3{fill:#E0C656;}\n\t.st4{fill:none;}\n\t.st5{fill:#FF6622;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    className: "st5",
    d: "M223.8,88.5L53.1,384.8c-7.3,13.6-2.3,30.5,11.3,37.9c4.5,2.4,9.7,3.6,14.8,3.3 h341.7c15.4,0.8,28.6-11.1,29.4-26.5c0.3-5.1-0.9-10.2-3.3-14.7L276.1,88.5c-8.9-14.4-27.8-18.9-42.3-10 C229.8,81,226.4,84.5,223.8,88.5z M268.9,173.2l-5.4,150.1h-27l-5.4-150.1H268.9z M249.8,386.4c-10.5-0.9-18.3-10.2-17.4-20.7 c0.9-10.5,10.2-18.3,20.7-17.4c9.9,0.9,17.4,9.1,17.4,19.1c-0.4,10.9-9.6,19.5-20.5,19.1C250,386.4,249.9,386.4,249.8,386.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.2,355.5l-0.4-0.7l-0.4-0.7L316.2,72.8l-0.4-0.6l-0.4-0.6c-7-11.4-16.9-20.7-28.6-27.1 c-11.3-6.2-24-9.4-36.9-9.4c-14.3,0-28.2,4-40.4,11.5c-10.1,6.3-18.8,14.9-25.1,25.1l-0.4,0.6l-0.4,0.6L21.6,354.2l-0.3,0.6 l-0.3,0.6c-9.4,17.5-11.5,37.6-5.8,56.6c5.7,19,18.4,34.7,35.9,44.1c10.8,5.8,23,8.9,35.3,8.9c0.8,0,1.6,0,2.4,0h322.6 c0.8,0,1.5,0,2.3,0c39.6,0,72.2-31,74.3-70.5C488.6,380.9,485.6,367.5,479.2,355.5z M450.3,399.5c-0.8,15.4-14,27.3-29.4,26.5 H79.2c-5.1,0.3-10.3-0.9-14.8-3.3c-13.6-7.3-18.6-24.3-11.3-37.9L223.8,88.5c2.5-4.1,5.9-7.5,10-10c14.4-8.9,33.3-4.4,42.3,10 L447,384.8C449.4,389.3,450.5,394.4,450.3,399.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "268.9,172.8 263.5,322.9 236.5,322.9 231.1,172.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.3,386c-10.5-0.9-18.3-10.2-17.4-20.7c0.9-10.5,10.2-18.3,20.7-17.4c9.9,0.9,17.4,9.1,17.4,19.1 c-0.4,10.9-9.6,19.5-20.5,19.1C248.5,386,248.4,386,248.3,386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.996fbc8a6c3b6d147e236a82553d2256.svg";
export { ForwardRef as ReactComponent };